import { getCrmCustomerTelDecrypt } from "../request/crm/customer/tel/decrypt/get.js";
async function getPhoneByServiceId(serviceId) {
  if (!serviceId)
    return "";
  const telEncrypt = await getCrmCustomerTelDecrypt({ serviceId: String(serviceId), scene: "design" });
  return telEncrypt.data;
}
export { getPhoneByServiceId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getPhoneByServiceId.js